import React, { useCallback, useRef, useEffect } from 'react';
import cn from 'classnames';

import { analyticService } from 'global/services';

import { NavigationItem } from './navigationItems';
import { scrollItemToLeft } from './navigationAnimate';
import css from './navigation.module.scss';


type NavigationButtonProps = {
    item: NavigationItem;
    isActive?: boolean;
    containerRef: React.RefObject<HTMLDivElement>;
    scrollingListRef: React.RefObject<HTMLDivElement>;
    onClick: (id: string) => void; // eslint-disable-line no-unused-vars
};

export function NavigationButton({
    item,
    isActive = false,
    containerRef,
    scrollingListRef,
    onClick: setActiveItemId,
}: NavigationButtonProps) {
    const {
        id, title, icon, trackId,
    } = item;

    const ref = useRef<HTMLButtonElement>(null);

    const handleClick = useCallback(() => {
        const bannerName = trackId ?? id;
        analyticService.push({
            bannerName,
            eventName: 'NY_click',
        });

        setActiveItemId(id);
    }, [id, trackId, setActiveItemId]);

    useEffect(() => {
        if (isActive) {
            scrollItemToLeft(containerRef.current!, ref.current!, scrollingListRef.current!);
        }
    }, [isActive, containerRef, scrollingListRef]);

    const buttonClasses = cn({
        [css.navigationButton]: true,
        [css.withIcon]: Boolean(icon),
        [css.active]: isActive,
    });

    return (
        <button
            type="button"
            className={buttonClasses}
            ref={ref}
            onClick={handleClick}
        >
            {icon && <img src={icon} alt={title} className={css.navigationIcon} />}
            <span>{title}</span>
        </button>
    );
}
